var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownCheveron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8995 13.3993L18.5919 6.70696C18.9824 6.31643 19.6155 6.31643 20.0061 6.70696L21.0919 7.79274C21.4824 8.18327 21.4824 8.81643 21.0919 9.20696L12.6066 17.6922C12.216 18.0828 11.5829 18.0828 11.1924 17.6922L2.70708 9.20696C2.31655 8.81643 2.31655 8.18327 2.70708 7.79274L3.79286 6.70696C4.18339 6.31643 4.81655 6.31643 5.20708 6.70696L11.8995 13.3993Z",
    fill: "#26436E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownCheveron);
export default __webpack_public_path__ + "static/media/DownCheveron.ffe3d29727b55aae250171e6e4305a4d.svg";
export { ForwardRef as ReactComponent };